import { render, staticRenderFns } from "./NotificationAdvanced.vue?vue&type=template&id=1a87c3d5&"
import script from "./NotificationAdvanced.vue?vue&type=script&lang=js&"
export * from "./NotificationAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports